import { Injectable } from '@angular/core';
import { GeneralService } from './general.service';
import { environment } from 'src/environments/environment';
import { MsgService } from '../local/msg.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FilterBaseModel } from '../../models/viewModel/filterBase.model';
import { Introduce } from '../../models/entity/introduce.model';

@Injectable({
  providedIn: 'root'
})
export class IntroduceService extends GeneralService {

  constructor(
    protected messageService: MsgService,
    protected httpClient: HttpClient,
  ) {
    super(messageService, httpClient, environment.apiUrl, 'Introduce');
  }

  public async getListIntroduces(viewModel: FilterBaseModel): Promise<Introduce[]> {
    let data = [];
    const res = await this.postCustomApi('GetListIntroduce', viewModel);
    if (this.isValidResponse(res)) {
      return data = res.data as Introduce[];
    }
    return [];
  }
}
